<script>
    // -- IMPORTS
	import { SortableList } from '@jhubbardsf/svelte-sortablejs';
    import { getLocalizedText } from "senselogic-gist";
    import { languageArrayStore } from "$src/lib/store/languageArrayStore";
    import Media from "./Media.svelte";
    import { toast } from '$src/lib/toast';
    import { fetchData } from '$src/lib/base';
    import FullLoading from '../Layout/FullLoading.svelte';

    // -- VARIABLES
    let 
    {
        blockGroupArray = $bindable()
    } = $props();
    let isLoading = $state( false );
    let newOrderedList = $state( [] );

    let sortedGroupBySectionNumber = $state( [] );

    // -- FUNCTIONS
    
    function dispatchOnSortEvent(
        ) 
    {
        let event = new CustomEvent(
            'on-sort-block-group', 
            {
                detail: 
                    {
                        blockGroupArray
                    },
                bubbles: true
            }
        );

        document.dispatchEvent(event);
    }


    // -- FUNCTIONS

    function updateIndices(
        fromIndex,
        toIndex
        )
    {
        let element = sortedGroupBySectionNumber[ fromIndex ]

        sortedGroupBySectionNumber.splice( fromIndex, 1 )
        sortedGroupBySectionNumber.splice( toIndex, 0, element )
    }

    // ~~

    async function handleSort(
        event
        )
    {

        updateIndices( event.oldIndex, event.newIndex )

        newOrderedList = sortedGroupBySectionNumber.map( ( block, index ) => 
            (
                {
                    ...block,
                    sectionPositionNumber: index + 1
                }
            )
        );

        isLoading = true;

        await saveBlockSectionOrder( newOrderedList );
        dispatchOnSortEvent();

        isLoading = false;
    }

    // ~~

    async function saveBlockSectionOrder(
        orderedArray
        )
    {
        try
        {
            let response =
                await fetchData(
                    '/api/block/set-section-order',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                            },
                        body: JSON.stringify( { orderedArray } ),
                        credentials: 'include'
                    }
                    );

            if ( response.error )
            {
                toast(
                    {
                        variant: 'error',
                        text: response.error
                    }
                    );
            }
            else
            {
                blockGroupArray = orderedArray;
                toast(
                    {
                        variant: 'success',
                        text: 'Blocks updated'
                    }
                    );
            }
        }
        catch ( error )
        {
            toast.error( 'Error while saving order' );
        }
    }

    // -- STATEMENTS

    $effect(
        () => 
        {
            if ( blockGroupArray?.length > 0 )
            {
                sortedGroupBySectionNumber = [...blockGroupArray].sort( 
                    ( a, b ) => 
                    {
                        if ( a.sectionPositionNumber < b.sectionPositionNumber ) return -1;
                        if ( a.sectionPositionNumber > b.sectionPositionNumber ) return 1;
                        return 0;
                    } 
                );
            }
        } 
    );
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .sortable-list-container
    {
        margin-top: 0.5rem;
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        cursor: grab;
    }

    .sortable-list-item
    {
        min-height: 5rem;
        max-width: 100%;
        border-radius: 0.5rem;
        padding: 1rem;

        display: flex;
        gap: 1rem;
        align-items: center;

        background: darkGrayColor;

        color: lightGoldColor;

        transition: all 0.2s linear;

        &:hover
        {
            background: darkGreyColor;
        }

        &:active
        {
            cursor: grabbing;
        }

        &:last-of-type
        {
            margin-bottom: 1rem;
        }
        
    }

    .sortable-list-item + .sortable-list-item
    {
        margin-top: 0.5rem;
    }

    .sortable-list-item-container
    {
        display: flex;
        gap: 1rem;
        align-items: center;
        overflow: hidden;

        width: 100%;
    }

    .item-media-container
    {
        height: 4.25rem;
        width: 7.5rem;
    }

    .item-title-container
    {
        overflow: hidden;
    
        max-width: 40%;

        text-overflow: ellipsis;
    }

    .item-title
    {
        overflow: hidden;

        max-width: 100%;

        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .button-container
    {
        display: flex;
        gap: 0.5rem;
    }

    .action-button
    {
        border-radius: 0.25rem;
        padding:  0.5rem 0.75rem;

        display: flex;
        gap: 0.5rem;

        cursor: pointer;
        transition: all .2s linear;
    }

    .edit
    {
        background: darkGrayColor;

        color: lightGreyColor;
    }

    .edit:hover
    {
        color: lightGoldColor;
    }

    .delete
    {
        background: #ef535060;

        color: redColor500;
    }
</style>


{#if isLoading}
    <FullLoading />
{:else}
    {#key blockGroupArray}
        <SortableList
            class="sortable-list"
            dragClass="active-drag-item"
            onEnd={ handleSort }
        >
            {#each sortedGroupBySectionNumber as block}
                <div class="sortable-list-item">
                    <div class="sortable-list-item-container">
                            <div class="arrows-outline-vertical-icon size-150"></div>
    
                            {#if block.mediaPath && block.mediaPath !== ''}
                                <div class="item-media-container">
                                    <Media
                                        mediaClass="block-image"
                                        mediaPath={ block.mediaPath }
                                        mediaSize={ '640' }
                                        mediaBackgroundSize={ 'cover' }
                                    />
                                </div>
                            {:else if block.mediaPathArray?.length > 0}
                                <div class="item-media-container">
                                    <Media
                                        mediaClass="block-image"
                                        mediaPath={ block.mediaPathArray[ 0 ] }
                                        mediaSize={ '640' }
                                        mediaBackgroundSize={ 'contain' }
                                    />
                                </div>
                            {/if}

                        <div class="item-title-container">
                            <span class="item-title">
                                {#if block?.sectionPositionNumber}
                                    {block.sectionPositionNumber + '. '} 
                                {/if}
                                { getLocalizedText( block.title ?? '', $languageArrayStore)}
                            </span>
                        </div>

                    </div>
                    <!-- <div class="button-container">
                        <button
                            type="button"
                            class="action-button edit"
                            onclick={() => {}}
                        >
                            <div class="light-gold-edit-icon size-150"></div>
                            Edit
                        </button>
                        <button
                            type="button"
                            class="action-button delete"
                            onclick={ () => {}}
                        >
                            <div class="red-500-trash-icon size-150"></div>
                            Delete
                        </button>
                    </div> -->
                </div>
            {/each}
        </SortableList>
    {/key}
{/if}
